"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.socketQueryParamsSchema = exports.authRequestBodySchema = exports.authEndpoint = void 0;
var joi_1 = __importDefault(require("joi"));
exports.authEndpoint = '/auth';
exports.authRequestBodySchema = joi_1.default.object({
    playerName: joi_1.default.string().required().min(3).max(12)
});
exports.socketQueryParamsSchema = joi_1.default.object({
    token: joi_1.default.string().required()
});
